const schedulerEnglish = {
  header: {
    title: "LinkedIn Scheduler",
    description: "Set which days and times your LinkedIn posts should be sent."
  },
  limits: {
    scheduled: "Scheduled posts: {count}",
    weekly: "Weekly limit: {limit}",
    remaining: "Remaining: {count}"
  },
  limitWarning: {
    used: "You have scheduled all your {limit} weekly posts. Upgrade your subscription for more.",
    upgrade: "Upgrade subscription",
    low: "You have {remaining} posts left for scheduling this week."
  },
  loading: "Loading your settings...",
  botDelivery: {
    title: "Bot Delivery Schedule",
    description: "Set when you want to receive the weekly posts from the bot",
    day: "Delivery day:",
    time: "Time:",
    info: "The first message will arrive on {day} at {time}. Subsequent messages will arrive when you have accepted a post."
  },
  postSchedule: {
    title: "LinkedIn Post Schedule",
    description: "Choose which days and times your LinkedIn posts should be published",
    days: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday"
    },
    addTime: "Add time",
    onePosts: "1 post",
    multiplePosts: "{count} posts"
  },
  summary: {
    title: "Summary:",
    description: "Your LinkedIn posts will be posted at the following times:",
    totalPosts: "Total scheduled posts: {count} of {limit}"
  },
  timeModal: {
    title: "Choose a time for {day}",
    label: "Select time:",
    info: "Posts at this time will be automatically shared on LinkedIn.",
    cancel: "Cancel",
    add: "Add time"
  },
  save: {
    button: "Save settings",
    success: "Your scheduling settings have been saved!",
    error: "An error occurred while saving your settings. Please try again later."
  },
  timezone: {
    label: "Timezone:",
    info: "All times are specified in timezone: {timezone}"
  },
  customerBanner: "You are editing schedule for {customerName}"
};

export default schedulerEnglish; 